(function(){
  if(window.__svmnav)return;window.__svmnav=1;
  var LINKS=[
    ['All','/collections/all'],
    ['Studs','/collections/stud-earrings'],
    ['Hoops','/collections/hoop-earrings'],
    ['Dangle & Drop','/collections/dangle-drop-earrings'],
    ['About','/pages/about'],
    ['Search','/search']
  ];
  var css=[
    "@media(max-width:900px){",
      ".nav .nav-left>a,.svh-nav .svh-left>a{display:none!important}",
      ".nav .nav-right a:not(.cart){display:none!important}",
      ".svm-burger{display:inline-flex!important}",
    "}",
    ".svm-burger{display:none;align-items:center;justify-content:center;width:30px;height:30px;padding:0;margin:0 8px 0 0;background:none;border:none;cursor:pointer;color:#1c1c1a;order:-1;-webkit-tap-highlight-color:transparent}",
    ".svm-burger svg{width:24px;height:24px}",
    ".svm-drawer{position:fixed;inset:0;z-index:3000;visibility:hidden}",
    ".svm-drawer.open{visibility:visible}",
    ".svm-back{position:absolute;inset:0;background:rgba(18,18,16,.42);opacity:0;transition:opacity .3s ease}",
    ".svm-drawer.open .svm-back{opacity:1}",
    ".svm-panel{position:absolute;top:0;left:0;right:0;background:#f4f1ea;transform:translateY(-105%);transition:transform .42s cubic-bezier(.4,.01,.16,1);padding:18px 26px 32px;box-shadow:0 24px 60px rgba(0,0,0,.18)}",
    ".svm-drawer.open .svm-panel{transform:translateY(0)}",
    ".svm-head{display:flex;justify-content:flex-end;margin-bottom:6px}",
    ".svm-close{background:none;border:none;font-size:30px;line-height:1;color:#1c1c1a;cursor:pointer;padding:2px 6px}",
    ".svm-panel a{display:block;font-family:Archivo,sans-serif;font-size:16px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;color:#1c1c1a;text-decoration:none;padding:16px 2px;border-bottom:1px solid rgba(28,28,26,.1)}",
    ".svm-panel a:last-child{border-bottom:none}",
    ".svm-panel a:active{color:#d95d28}"
  ].join("");
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
  function build(){
    function shown(e){return e&&getComputedStyle(e).display!=='none';}
    var hg=document.querySelector('#header-group');
    var mh=document.querySelector('#MainContent header');
    var vh=shown(hg)?hg:(shown(mh)?mh:(hg||mh));
    if(!vh)return;
    var right=vh.querySelector('.svh-right,.nav-right');
    if(!right||right.querySelector('.svm-burger'))return;
    var b=document.createElement('button');
    b.className='svm-burger';b.setAttribute('aria-label','Open menu');
    var svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');
    svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.7');
    svg.setAttribute('stroke-linecap','round');
    var p=document.createElementNS('http://www.w3.org/2000/svg','path');
    p.setAttribute('d','M3 6h18M3 12h18M3 18h18');svg.appendChild(p);b.appendChild(svg);
    right.insertBefore(b,right.firstChild);
    var d=document.createElement('div');d.className='svm-drawer';
    var back=document.createElement('div');back.className='svm-back';d.appendChild(back);
    var panel=document.createElement('div');panel.className='svm-panel';
    var head=document.createElement('div');head.className='svm-head';
    var closeBtn=document.createElement('button');closeBtn.className='svm-close';
    closeBtn.setAttribute('aria-label','Close menu');closeBtn.textContent='×';
    head.appendChild(closeBtn);panel.appendChild(head);
    LINKS.forEach(function(l){var a=document.createElement('a');a.href=l[1];a.textContent=l[0];panel.appendChild(a);});
    d.appendChild(panel);document.body.appendChild(d);
    function open(){d.classList.add('open');document.documentElement.style.overflow='hidden';}
    function close(){d.classList.remove('open');document.documentElement.style.overflow='';}
    b.addEventListener('click',open);
    back.addEventListener('click',close);
    closeBtn.addEventListener('click',close);
  }
  function wrapNum(){
    var h=document.querySelector('.news h2');
    if(h&&!h.querySelector('.num')&&h.innerHTML.indexOf('10%')>-1){
      h.innerHTML=h.innerHTML.replace('10%','<span class="num">10%</span>');
    }
  }
  function fixCur(){
    try{
      if(!window.Shopify||!Shopify.currency||!Shopify.currency.active)return;
      var cur=Shopify.currency.active;
      var sels=document.querySelectorAll('form.sv-loc select, select[name="country_code"]');
      sels.forEach(function(sel){
        for(var i=0;i<sel.options.length;i++){
          if((sel.options[i].text||'').trim()===cur){ sel.selectedIndex=i; break; }
        }
      });
    }catch(e){}
  }
  function init(){build();wrapNum();fixCur();}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
